<template>
  <div>
    <v-toolbar flat color="transparent">
      <v-btn @click="displayAddModal = true" dark color="primary"
        >代理店の追加</v-btn
      >
      <div class="checkboxDescription"><span>表示する代理店：</span></div>
      <div>
        <v-checkbox
          :key="index"
          v-for="(option, index) in selectOptions"
          :label="option.text"
          @change="onActiveFilterChange(option.value)"
          :input-value="searchAndFilter.activeFilter[option.value]"
          class="checkbox"
          hide-details
          messages="none"
        />
      </div>
      <v-spacer />
      <EditAgencySearchBox @onTextChange="onTextChange" />
      <PageSelect
        :value="agencyList"
        @input="pagination"
        style="width:200px;"
        class="pl-4"
      />
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="agencyList.items"
      :disable-initial-sort="true"
      :rows-per-page-items="[-1]"
      :loading="loading.searchResult"
      hide-actions
      class="elevation-1"
    >
      <template #headers="props">
        <th
          v-for="header in props.headers"
          :key="header.text"
          :class="[
            sortOptions.descending ? 'desc' : 'asc',
            header.value === sortOptions.sortBy ? 'active' : '',
            header.align === 'center' ? 'text-xs-center' : '',
            header.align === 'right' ? 'text-xs-right' : '',
            header.align === 'left' ? 'text-xs-left' : '',
          ]"
          :aria-sort="header.sortable ? '' : 'none'"
          @click="changeSort(header)"
        >
          {{ header.text }}
          <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
        </th>
      </template>

      <template slot="items" slot-scope="props">
        <td class="justify-center align-center layout px-0">
          <v-icon @click="openEditModal(props.item)" small>edit</v-icon>
          <!-- DELETE API実装待ち
          <v-icon small class="mr-4" @click="openEditModal(props.item)">
            edit
          </v-icon>
          <v-icon small @click="deleteItem(props.item)">
            delete
          </v-icon>
          -->
        </td>
        <td class="text-xs-left no-wrap">
          <AppAgencyName
            :agency="props.item"
            :with-system-owner="isSuperAdmin"
          />
        </td>
        <td class="text-xs-left">
          <AppStatus :value="props.item.status" :showText="false" with-icon />
        </td>
        <td class="text-xs-left no-wrap">{{ props.item.salesAccountName }}</td>
        <td class="text-xs-left no-wrap">{{ props.item.email }}</td>
      </template>
      <template slot="no-data">
        <div>登録されている代理店はありません</div>
      </template>
    </v-data-table>
    <EditModal
      v-model="displayModal"
      :is-edit="displayEditModal"
      :item="currentItem"
      :push-item="pushItemMethod"
    />
    <ConfirmModal
      v-model="displayConfirmModal"
      :loading="deleting"
      @clickOk="execDeleteItem"
      message="削除します。よろしいですか？"
    />
  </div>
</template>

<script>
import { actions, snackbarType } from '@/vuex/modules/ui/snackbar/constants'
import EditModal from '@/components/Admin/EditAgency/EditModal'
import EditAgencySearchBox from './EditAgencySearchBox'
import PageSelect from '@/components/Shared/Search/PageSelect'
import ConfirmModal from '@/components/Shared/CrudUI/ConfirmModal.vue'
import JAPANESE from '@/constants/japanese'
import advSearch from '@/components/Admin/Util/advSearch'

export default {
  components: {
    EditModal,
    EditAgencySearchBox,
    PageSelect,
    ConfirmModal,
  },
  props: {
    loading: {
      type: Object,
      default: () => {},
    },
    agencyList: {
      type: Object,
      default: () => {},
    },
    pushNewItem: {
      type: Function,
      default: () => {},
    },
    pushEditedItem: {
      type: Function,
      default: () => {},
    },
    isSuperAdmin: Boolean,
    searchAndFilter: {
      type: Object,
      required: true,
    },
    sortOptions: {
      type: Object,
      required: true,
    },
    onActiveFilterChange: {
      type: Function,
      default: () => {},
    },
    changeSort: {
      type: Function,
      default: () => {},
    },
  },
  data: () => ({
    headers: [
      {
        text: JAPANESE.actions,
        value: 'actions',
        align: 'center',
        sortable: false,
      },
      {
        text: JAPANESE.agencyName,
        value: 'name',
        align: 'left',
        sortable: true,
      },
      {
        text: JAPANESE.status,
        value: 'status',
        align: 'left',
        sortable: false,
      },
      {
        text: JAPANESE.manager,
        value: 'staffName',
        align: 'left',
        sotable: false,
      },
      { text: JAPANESE.email, value: 'email', align: 'left', sortabl: false },
    ],
    currentItem: undefined,
    displayAddModal: false,
    displayEditModal: false,
    displayConfirmModal: false,
    deleting: false,
    searchFunc: undefined,
  }),
  computed: {
    selectOptions() {
      return [
        { text: '有効', value: 'active' },
        { text: '無効', value: 'inactive' },
      ]
    },
    displayModal: {
      get() {
        return this.displayAddModal || this.displayEditModal
      },
      set() {
        // falseしか入って来ない
        this.displayEditModal = false
        this.displayAddModal = false
      },
    },
    pushItemMethod() {
      return this.displayAddModal ? this.pushNewItem : this.pushEditedItem
    },
  },
  watch: {
    agencyList(val) {
      this.searchFunc = advSearch({ items: val })
    },
  },
  mounted() {
    if (this.$route.hash === '#add') {
      this.displayAddModal = true
    }
  },
  methods: {
    openEditModal(item) {
      this.currentItem = item
      this.displayEditModal = true
    },
    deleteItem(item) {
      this.currentItem = item
      this.displayConfirmModal = true
    },
    async execDeleteItem() {
      this.deleting = true
      try {
        await this.$store.dispatch('agency/DELETE_AGENCY', {
          id: this.currentItem.id,
        })
        await this.$store.dispatch(actions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '削除完了しました',
        })
      } catch (e) {
        const error = new Error('削除に失敗しました。')
        this.displayConfirmModal = false
        this.deleting = false
        throw error
      }
      this.displayConfirmModal = false
      this.deleting = false
    },
    pagination(pageNo) {
      this.$emit('pagination', pageNo)
    },
    onTextChange(keyword) {
      this.$emit('onTextChange', keyword)
    },
  },
}
</script>

<style scoped>
.checkboxDescription {
  width: 130px;
  padding-top: 24px;
  padding-bottom: 20px;
  font-size: 16px;
  color: #666;
}
.checkbox {
  padding-top: 8px;
  display: inline-block;
  margin-right: 15px;
}

.no-wrap {
  white-space: nowrap;
}
.title {
  font-weight: normal;
  color: #614545;
}
</style>
